import Chart from '../../components/IDPCharts/IDPChart'
import getLineChartOptions from './lineChartOptions'
import styles from './LineChart.module.scss'

const LineChartTrend = ({ data  }) => {
  const uhg_data = data
    .filter((d) => d.uhg_count > 0)
    .map((d) => {
      return [new Date(d.month_date).getTime(), parseInt(d.uhg_count)]
    })

  const scale_estimate_data = data.map((d) => {
    return [new Date(d.month_date).getTime(), parseInt(d.scale_estimate_count)]
  })

  const accuracyChartData = [
    {
      data: uhg_data,
    },
    {
      data: scale_estimate_data,
    },
  ]
  const accuracyChartOptions = getLineChartOptions(accuracyChartData)

  return (
    <div className={styles.chartDiv}>
    
      <div className={styles.container}>
          <Chart chartType="arearange" chartOptions={accuracyChartOptions} />
          <span className={styles.bottomText}>
            Interact with the Graph Key to Show, Hide or Highlight specific
            Lines.
          </span>
      </div>
    </div>
  )
}

export default LineChartTrend
